import { SUMMARY_TABLE, SUMMARY_TILE, SUMMARY_TRENDS } from './constants/analytics/contexts';
import type { ProductType } from './types/summary.types';
import type { SummaryBaseContext, SummaryProductContext } from './constants/analytics/contextTypes';

const SUMMARY_CONTEXT_AND_PRODUCT_SEPARATOR = '__';

export class SummaryProductContextService {
  static isSummaryProductContext(context: string): context is SummaryProductContext {
    const [baseContext] = this.decodeContext(context);

    return baseContext && (baseContext === SUMMARY_TABLE || baseContext === SUMMARY_TRENDS || baseContext === SUMMARY_TILE);
  }

  static decodeContext(context: string): [SummaryBaseContext, ProductType] {
    const [baseContext, product] = context.split(SUMMARY_CONTEXT_AND_PRODUCT_SEPARATOR);

    return [baseContext, product] as [SummaryBaseContext, ProductType];
  }

  static encodeContext(summaryBaseContext: SummaryBaseContext, product: ProductType): SummaryProductContext {
    return `${summaryBaseContext}${SUMMARY_CONTEXT_AND_PRODUCT_SEPARATOR}${product}`;
  }
}
